import { useState } from "react";
import { motion } from "framer-motion";
//import blocksShuffle from "/assets/videos/blocks-shuffle-4.svg"
//import asd from "./index.svg"
//import aaa from "/assets/videos/Mexican fella.webm"
//import bbb from "/assets/videos/MexicanFella.gif"
//import aaa from "/assets/videos/Mexicanfella.webm"

const mexicanfella = "/assets/videos/LoaderOverlay/Mexicanfella.webm"

export default function LoaderOverlay() {
	const [startExit, setStartExit] = useState(false);

	const animationConfigs = [
		{
			values: "0;100;100;130;130;160;160;200",
			keyTimes: "0;0.2;0.3;0.4;0.5;0.6;0.7;1",
			dur: "2",
			fill: "freeze",
			color: "#FF9E0B",
		},
		{
			values: "0;100;90;100;150;200",
			keyTimes: "0;0.4;0.5;0.6;0.8;1",
			dur: "2",
			fill: "freeze",
			color: "#FF9E0B",
		},
		{
			values: "0;100;100;130;160;200",
			keyTimes: "0;0.5;0.6;0.75;0.9;1",
			dur: "2.5",
			fill: "freeze",
			color: "#FF9E0B",
		},
		{
			values: "0;50;100;100;120;120;150;200",
			keyTimes: "0;0.2;0.4;0.5;0.6;0.65;0.8;1",
			dur: "3",
			fill: "freeze",
			color: "#FF9E0B",
		},
		{
			values: "0;100;100;120;140;160;180;200",
			keyTimes: "0;0.3;0.4;0.5;0.6;0.7;0.85;1",
			dur: "3",
			fill: "freeze",
			color: "#FF9E0B",
		},
	];

	const randomConfig =
		animationConfigs[Math.floor(Math.random() * animationConfigs.length)];

	return (
	<>{!startExit && (
		<motion.div
			className={`fixed top-0 left-0 w-screen h-screen flex flex-col gap-10 justify-center items-center bg-black z-[9999] overflow-hidden ${startExit ? "hidden" : ""}`}
			initial={{ transform: "translateY(0)" }}
			animate={!startExit ? { transform: "translateY(-100%)" } : {}}
			transition={{
				duration: 0.8,
				ease: "circIn",
				//delay: 4.5,
				delay: parseFloat(randomConfig.dur) + 0.7,
			}}
			onAnimationComplete={() => setStartExit(true)}
		>
			<video
				autoPlay
				loop
				muted
				playsInline
				width={150}
				height={150}
				preload="auto"
				className="w-[30vw] sm:w-[15vw] md:w-[10vw] 2xl:w-[15vw] aspect-square object-cover" 
			>
				<source src={mexicanfella} type="video/webm" />
			</video>
			
			{/* <img 
				src={bbb} 
				alt="" 
				className="w-[30vw] sm:w-[15vw] md:w-[10vw] 2xl:w-[15vw] aspect-square object-cover" 
				loading="eager"
				fetchPriority={"high"}
			/> */}
			{/* <img src={asd} alt="" className="w-[15vw] aspect-square object-cover" /> */}
			
			<svg
				className="scale-50 xl:scale-100 2xl:scale-180"
				width="200"
				height="5"
				viewBox="0 0 200 5"
				preserveAspectRatio="xMidYMid meet"
			>
				<rect width="200" height="5" rx="2" fill="#eee" />
				<rect height="5" rx="5" fill={`${randomConfig.color}`}>
					<animate
						attributeName="width"
						values={`${randomConfig.values}`}
						keyTimes={`${randomConfig.keyTimes}`}
						dur={`${randomConfig.dur}s`}
						fill={`${randomConfig.fill}`}
					/>
				</rect>
			</svg>
		</motion.div>
	)}</>
	);
}